module.exports = __webpack_public_path__ + "static/media/licenta15.f85b8847.png";